import react, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { AxiosResponse } from 'axios';

import useLoadingStore from 'zustands/useLoadingStore';
import useApi from 'hooks/useApi';
import useErrorLog from 'hooks/useErrorLog';

import { IEmpInPayTransfer, IFormDataInPaystatement } from 'types/salary';
import { addComma } from 'constants/utils';
import DetailPayTop from 'components/salary/DetailPayTop';
import WithSideBarAndNavBar from 'layouts/withSideBarAndNavBar/withSideBarAndNavBar';
import DetailPayMid from 'components/salary/DetialPayMid';
import './DetailPay.scss';
import usePaystatementStore from 'zustands/usePaystatementStore';
import { isMobile } from 'react-device-detect';
import useStoreStore from 'zustands/useStoreStore';

export interface ISections {
  title: string;
  value: string;
}
export interface ISectionsInfo {
  title: string;
  formula: string;
  value: string;
}

const PointToPercent = (value: any) => {
  let Format = (Number(value) * 10000) / 100;
  return Format;
};

const DetailPay = () => {
  const location = useLocation();
  const { sendDate, acceptEmpSeq, payStoreSeq, payKakaoSeq } = usePaystatementStore();
  const { storeSeqNumber } = useStoreStore();
  const MEMBER_INDEX = location.state?.memberIndex ?? acceptEmpSeq;
  const date = location.state.date ?? sendDate;
  const pkIndex = location.state.pkIndex ?? payKakaoSeq;
  const { fromType } = location.state;
  const { setLoadingState } = useLoadingStore();

  const { webApiNode } = useApi();
  const { checkErrorLog } = useErrorLog();

  // const { handlePopUp, PK_SEQ } = props;

  // const PK_INDEX = Router.router.query.PK ? Router.router.query.PK : PK_SEQ;
  const PK_INDEX = pkIndex !== 0 ? pkIndex : '';
  // 점주 구분
  const [isOwner, setIsOwner] = useState<boolean>(false);
  // 직원정보
  const [DetailData, setDetailData] = useState<IEmpInPayTransfer>({
    MEMBER_INDEX: 0, // 미사용
    NAME: '', // 직원명
    SS_NUMBER: '', // 주민등록번호
    department: '', // 부서
    rank: '', // 직급
    LAST_PUSH_DATE: '-', // 급여 전송시간
    STANDARD_TAX: '0', // 공제유형
    PayDay: '', // 지급일
  });
  // 급여유형
  const [PAYTYPE, setPAYTYPE] = useState('0');
  // 실지급액
  const [RealPay, setRealPay] = useState<string>('0');
  // 지급내역
  const [ProvideData, setProvideData] = useState<ISections[]>([]);
  // 지급 계산 내역
  const [ProvideDataInfo, setProvideDataInfo] = useState<ISectionsInfo[]>([]);
  // 공제내역
  const [DeductionData, setDeductionData] = useState<ISections[]>([]);
  // 공제 계산 내역
  const [DeductionDataInfo, setDeductionDataInfo] = useState<ISectionsInfo[]>([]);

  const FetchEmpInfo = async () => {
    try {
      setLoadingState({ isFetchLoading: true });
      // const apiName = isMobile ? `getMemberInformationApp` : `getMemberInformation`;
      const { data }: AxiosResponse['data'] = await webApiNode('post', `/auth/getMemberInformationApp`, {
        MEMBER_INDEX,
        PK_INDEX,
        SELECT_DATE: moment(date).format('YYYYMM'),
      });
      // console.log('/auth/${apiName}_data', data);

      if (data.resultCode === 0) {
        const { NAME, PAYDAY, SS_NUMBER, RANK, DEPARTMENT, LAST_PUSH_DATE, STANDARD_TAX } = data.resultData;
        setDetailData({
          ...DetailData,
          NAME: NAME,
          SS_NUMBER: SS_NUMBER,
          department: DEPARTMENT == '' ? '-' : DEPARTMENT,
          rank: RANK == '' ? '-' : RANK,
          LAST_PUSH_DATE: LAST_PUSH_DATE,
          STANDARD_TAX: STANDARD_TAX,
          PayDay: PAYDAY == '말일' ? PAYDAY : `${PAYDAY}일`,
        });
      } else {
        throw new Error(data.resultMsg);
      }
    } catch (err) {
      checkErrorLog(err, ' /auth/getMemberInformation');
    } finally {
      setLoadingState({ isFetchLoading: false });
    }
  };

  const FetchPayDetail = async () => {
    try {
      setLoadingState({ isFetchLoading: true });
      const apiName = isMobile ? `getPaystubMemberDetailV2App` : `getPaystubMemberDetailV2`;
      const { data }: AxiosResponse['data'] = await webApiNode(
        'post',
        // `/auth/${apiName}`,
        // isMobile
        //   ? {
        //       STORE_SEQ: payStoreSeq ? payStoreSeq : 0,
        //       MEMBER_INDEX: MEMBER_INDEX.toString(),
        //       SELECT_DATE: moment(date).format('YYYYMM'),
        //       PK_INDEX,
        //     }
        //   : {
        //       MEMBER_INDEX: MEMBER_INDEX.toString(),
        //       SELECT_DATE: moment(date).format('YYYYMM'),
        //       PK_INDEX,
        //     },
        `/auth/getPaystubMemberDetailV2App`,
        {
          STORE_SEQ: isMobile ? (payStoreSeq ? payStoreSeq : 0) : storeSeqNumber.toString(),
          MEMBER_INDEX: MEMBER_INDEX.toString(),
          SELECT_DATE: moment(date).format('YYYYMM'),
          PK_INDEX,
        },
      );
      // console.log('/auth/getPaystubMemberDetailV2_data', data);

      if (data.resultCode === 0) {
        const { DATA } = data.resultData;
        // 지급액합계
        let TotalPay = 0;
        // 기본급2 사용 여부
        const useSecondDefaultPay = DATA.PAY_ARRAY2 !== null;
        let PAY2 = 0; // 기본급2 급여
        let hasWeekHour2 = false; // 주휴수당2 시간 표시여부
        let hasWeekMin2 = false; // 주휴수당2 분 표시여부
        DATA.PAY_ARRAY.map((item: IFormDataInPaystatement) => {
          if (item.USE_YN == 'Y') {
            if (item.ITEM == '기본급') {
              if (DATA.PAY_TYPE == '0') {
                const hasWeekMin = item.VALUE.split(',').length > 5;
                TotalPay = TotalPay + Number(hasWeekMin ? item.VALUE.split(',')[5] : item.VALUE.split(',')[4]);
              } else {
                TotalPay = TotalPay + Number(item.VALUE.split(',')[2]);
              }
            } else {
              if (item.ITEM == '연장근로수당' || item.ITEM == '야간근로수당' || item.ITEM == '휴일근로수당') {
                TotalPay = TotalPay + Number(item.VALUE.split(',')[2]);
              } else {
                TotalPay = TotalPay + Number(item.VALUE);
              }
            }
          }
        });
        if (useSecondDefaultPay) {
          TotalPay += Number(DATA.PAY_ARRAY2.split(',')[5]);
          hasWeekHour2 = DATA.PAY_ARRAY2.split(',')[3] !== '0' ? true : false;
          hasWeekMin2 = DATA.PAY_ARRAY2.split(',')[4] !== '0' ? true : false;
        }
        // console.log('TotalPay', TotalPay);
        // 공제액합계
        let DeducPay = 0;
        DATA.DEDUC_ARRAY.map((item: IFormDataInPaystatement) => {
          if (item.USE_YN == 'Y') {
            DeducPay = DeducPay + Number(item.VALUE);
          }
        });
        // console.log('DeducPay', DeducPay);
        let PROV = [{ title: '지급액 합계', value: TotalPay.toString() }];
        let PROV_INFO: ISectionsInfo[] = [];
        let DEDUC = [{ title: '공제액 합계', value: DeducPay.toString() }];
        let DEDUC_INFO: ISectionsInfo[] = [];
        DATA.PAY_ARRAY.map((item: IFormDataInPaystatement) => {
          if (item.USE_YN == 'Y') {
            if (item.ITEM == '기본급') {
              if (DATA.PAY_TYPE == '0') {
                const hasWeekMin = item.VALUE.split(',').length > 5;
                const weekHourPay = (Number(item.VALUE.split(',')[2]) * 8 * Number(item.VALUE.split(',')[3])) / 40;
                const weekMinPay =
                  (Number(item.VALUE.split(',')[2]) * 8 * (Number(item.VALUE.split(',')[4]) / 60)) / 40;
                const WEEKENDPAY = Math.ceil((weekHourPay + weekMinPay) / 10) * 10;
                const PAY = Number(item.VALUE.split(',')[hasWeekMin ? 5 : 4]) - WEEKENDPAY;
                PROV.push({ title: item.ITEM, value: PAY.toString() });
                if (useSecondDefaultPay) {
                  PAY2 =
                    Math.ceil(
                      (DATA.PAY_ARRAY2.split(',')[0] * DATA.PAY_ARRAY2.split(',')[2] +
                        (DATA.PAY_ARRAY2.split(',')[1] * DATA.PAY_ARRAY2.split(',')[2]) / 60) /
                        10,
                    ) * 10;
                  PROV.push({ title: '기본급2', value: PAY2.toString() });
                }
                PROV.push({
                  title: '주휴수당',
                  value: WEEKENDPAY.toString(),
                });
                // 주휴수당2 사용한 경우
                if (
                  useSecondDefaultPay &&
                  (DATA.PAY_ARRAY2.split(',')[3] !== '0' || DATA.PAY_ARRAY2.split(',')[4] !== '0')
                ) {
                  PROV.push({
                    title: '주휴수당2',
                    value: (Number(DATA.PAY_ARRAY2.split(',')[5]) - PAY2).toString(),
                  });
                }
              } else {
                PROV.push({
                  title: item.ITEM,
                  value: item.VALUE.split(',')[2],
                });
              }
            } else {
              if (item.ITEM == '연장근로수당' || item.ITEM == '야간근로수당' || item.ITEM == '휴일근로수당') {
                PROV.push({
                  title: item.ITEM,
                  value: item.VALUE.split(',')[2],
                });
              } else {
                PROV.push({ title: item.ITEM, value: item.VALUE });
              }
            }
          }
        });
        DATA.PAY_ARRAY.map((item: IFormDataInPaystatement) => {
          if (item.USE_YN == 'Y') {
            // console.log('item', item);
            if (item.ITEM == '기본급') {
              let PAY = 0;
              let PAY2 = 0;
              let TIME = `${item.VALUE.split(',')[0] !== '0' ? item.VALUE.split(',')[0] : '0'}시간 ${
                item.VALUE.split(',')[1] !== '0' ? item.VALUE.split(',')[1] : '0'
              }분`;
              let TOTALOWORKTIME = '0';
              let TIME2 = '0';
              let HOUR = Number(item.VALUE.split(',')[0]);
              let MIN = Number(item.VALUE.split(',')[0]);
              if (useSecondDefaultPay) {
                HOUR =
                  Number(item.VALUE.split(',')[0]) +
                  Number(DATA.PAY_ARRAY2.split(',')[0]) +
                  Math.ceil((Number(item.VALUE.split(',')[1]) + Number(DATA.PAY_ARRAY2.split(',')[1])) / 60);
                MIN = (Number(item.VALUE.split(',')[1]) + Number(DATA.PAY_ARRAY2.split(',')[1])) % 60;
                TOTALOWORKTIME = `${HOUR}시간${MIN}분`;
                if (HOUR === 0) TOTALOWORKTIME = `${MIN}분`;
                if (MIN === 0) TOTALOWORKTIME = `${HOUR}시간`;
                TIME2 = `${DATA.PAY_ARRAY2.split(',')[0]}시간${DATA.PAY_ARRAY2.split(',')[1]}분`;
                if (DATA.PAY_ARRAY2.split(',')[0] == '0') TIME2 = `${DATA.PAY_ARRAY2.split(',')[1]}분`;
                if (DATA.PAY_ARRAY2.split(',')[1] == '0') TIME2 = `${DATA.PAY_ARRAY2.split(',')[0]}시간`;
              }
              // if (item.VALUE.split(',')[0] == '0' && item.VALUE.split(',')[1] == '0') {
              //   PAY = 0;
              // } else {
              if (DATA.PAY_TYPE == '0') {
                const hasWeekMin = item.VALUE.split(',').length > 5;
                const weekHourPay = (Number(item.VALUE.split(',')[2]) * 8 * Number(item.VALUE.split(',')[3])) / 40;
                const weekMinPay =
                  (Number(item.VALUE.split(',')[2]) * 8 * (Number(item.VALUE.split(',')[4]) / 60)) / 40;
                let WEEKENDPAY = Math.ceil((weekHourPay + weekMinPay) / 10) * 10;
                let secondDefaultPay = 0;
                PAY = Number(item.VALUE.split(',')[2]);
                PROV_INFO.push({
                  title: '총근로시간',
                  formula: `-`,
                  value: TOTALOWORKTIME,
                });
                PROV_INFO.push({
                  title: item.ITEM,
                  formula: `${addComma(PAY.toFixed(0))}원 X ${TIME}`,
                  value: (Number(item.VALUE.split(',')[hasWeekMin ? 5 : 4]) - WEEKENDPAY).toString(),
                });
                if (useSecondDefaultPay) {
                  PAY2 = DATA.PAY_ARRAY2.split(',')[2];
                  secondDefaultPay =
                    Math.floor(
                      (Number(DATA.PAY_ARRAY2.split(',')[0]) * Number(DATA.PAY_ARRAY2.split(',')[2]) +
                        (Number(DATA.PAY_ARRAY2.split(',')[1]) * Number(DATA.PAY_ARRAY2.split(',')[2])) / 60) /
                        10,
                    ) * 10;
                  PROV_INFO.push({
                    title: '기본급2',
                    formula: `${addComma(PAY2.toString())}원 X ${TIME2}`,
                    value: secondDefaultPay.toString(),
                  });
                }
                PROV_INFO.push({
                  title: '주휴수당',
                  formula:
                    item.VALUE.split(',')[3] == '0' && (!hasWeekMin || (hasWeekMin && item.VALUE.split(',')[4] == '0'))
                      ? '-'
                      : `${addComma(Math.round(Number(item.VALUE.split(',')[2])).toString())}원 X 8시간 X ${
                          item.VALUE.split(',')[3]
                        }시간${
                          hasWeekMin && item.VALUE.split(',')[4] !== '0' ? ' ' + item.VALUE.split(',')[4] + '분' : ''
                        } / 40`,
                  value: WEEKENDPAY.toString(),
                });
                if (
                  useSecondDefaultPay &&
                  (DATA.PAY_ARRAY2.split(',')[3] !== '0' || DATA.PAY_ARRAY2.split(',')[4] !== '0')
                ) {
                  PROV_INFO.push({
                    title: '주휴수당2',
                    formula:
                      DATA.PAY_ARRAY2.split(',')[3] == '0' && DATA.PAY_ARRAY2.split(',')[4] == '0'
                        ? '-'
                        : `${addComma(Math.round(Number(DATA.PAY_ARRAY2.split(',')[2])).toString())}원 X 8시간 X ${
                            hasWeekHour2 ? DATA.PAY_ARRAY2.split(',')[3] + '시간' : ''
                          }${hasWeekMin2 ? (hasWeekHour2 ? ' ' : '') + DATA.PAY_ARRAY2.split(',')[4] + '분' : ''} / 40`,
                    value: (Number(DATA.PAY_ARRAY2.split(',')[5]) - secondDefaultPay).toString(),
                  });
                }
              } else if (DATA.PAY_TYPE == '1') {
                PAY = Number(item.VALUE.split(',')[1]);
                TIME = `${item.VALUE.split(',')[0]}일`;
                PROV_INFO.push({
                  title: '총근무일수',
                  formula: `-`,
                  value: TIME,
                });
                PROV_INFO.push({
                  title: item.ITEM,
                  formula: `${addComma(PAY.toFixed(0))}원 X ${TIME}`,
                  value: item.VALUE.split(',')[2],
                });
              } else {
                PAY =
                  (Number(item.VALUE.split(',')[2]) /
                    (Number(Number(item.VALUE.split(',')[0]) * 60) + Number(item.VALUE.split(',')[1]))) *
                  60;
                if (item.VALUE.split(',')[0] == '0') {
                  TIME = `${item.VALUE.split(',')[1]}분`;
                }
                if (item.VALUE.split(',')[1] == '0') {
                  TIME = `${item.VALUE.split(',')[0]}시간`;
                }
                PROV_INFO.push({
                  title: '총근로시간',
                  formula: `-`,
                  value: TIME,
                });
                PROV_INFO.push({
                  title: `${item.ITEM}`,
                  formula: `${addComma(PAY.toFixed(0))}원 X ${TIME}`,
                  value: item.VALUE.split(',')[2],
                });
              }
              // }
            } else if (item.ITEM == '연장근로수당' || item.ITEM == '야간근로수당' || item.ITEM == '휴일근로수당') {
              let PAY = 0;
              if (item.VALUE.split(',')[0] == '0' && item.VALUE.split(',')[1] == '0') {
                PAY = 0;
              } else {
                PAY =
                  (Number(item.VALUE.split(',')[2]) /
                    (Number(Number(item.VALUE.split(',')[0]) * 60) + Number(item.VALUE.split(',')[1]))) *
                  60;
              }
              let TIME = `${item.VALUE.split(',')[0]}시간${item.VALUE.split(',')[1]}분`;
              if (item.VALUE.split(',')[0] == '0') {
                TIME = `${item.VALUE.split(',')[1]}분`;
              }
              if (item.VALUE.split(',')[1] == '0') {
                TIME = `${item.VALUE.split(',')[0]}시간`;
              }
              PROV_INFO.push({
                title: item.ITEM,
                formula: `${addComma(Math.round(PAY).toString())}원 X ${TIME}`,
                value: item.VALUE.split(',')[2],
              });
            } else {
              PROV_INFO.push({
                title: item.ITEM,
                formula: '-',
                value: item.VALUE,
              });
            }
          }
        });
        let GUNGANG = '';
        DATA.DEDUC_ARRAY.map((item: IFormDataInPaystatement) => {
          if (item.USE_YN == 'Y') {
            if (item.ITEM == '건강보험') {
              GUNGANG = item.VALUE;
            }
            if (item.ITEM == '국민연금' || item.ITEM == '고용보험') {
              DEDUC.push({ title: item.ITEM, value: item.VALUE });
              DEDUC_INFO.push({
                title: item.ITEM,
                formula: `${addComma(TotalPay.toString())} X ${PointToPercent(item.FORMULA)}%`,
                value: item.VALUE,
              });
            } else if (item.ITEM == '장기요양보험') {
              DEDUC.push({ title: item.ITEM, value: item.VALUE });
              DEDUC_INFO.push({
                title: item.ITEM,
                formula: `${addComma(GUNGANG)} X ${PointToPercent(item.FORMULA)}%`,
                value: item.VALUE,
              });
            } else if (item.ITEM == '건강보험') {
              DEDUC.push({ title: item.ITEM, value: item.VALUE });
              DEDUC_INFO.push({
                title: item.ITEM,
                formula: `${addComma(TotalPay.toString())} X ${PointToPercent(item.FORMULA)}%`,
                value: item.VALUE,
              });
            } else if (item.ITEM == '근로소득세') {
              DEDUC.push({ title: item.ITEM, value: item.VALUE });
              DEDUC_INFO.push({
                title: item.ITEM,
                formula: `간이세액표 기준`,
                value: item.VALUE,
              });
            } else if (item.ITEM == '지방소득세') {
              DEDUC.push({ title: item.ITEM, value: item.VALUE });
              DEDUC_INFO.push({
                title: item.ITEM,
                formula: `근로소득세 X 10%`,
                value: item.VALUE,
              });
            } else {
              DEDUC.push({ title: item.ITEM, value: item.VALUE });
              DEDUC_INFO.push({
                title: item.ITEM,
                formula: '-',
                value: item.VALUE,
              });
            }
          }
        });
        setRealPay((TotalPay - DeducPay).toString());
        setProvideData(PROV);
        setProvideDataInfo(PROV_INFO);
        setDeductionData(DEDUC);
        setDeductionDataInfo(DEDUC_INFO);
        setPAYTYPE(DATA.PAY_TYPE);
      } else {
        throw new Error(data.resultMsg);
      }
    } catch (err) {
      checkErrorLog(err, ' /auth/getPaystubMemberDetailV2');
    } finally {
      setLoadingState({ isFetchLoading: false });
    }
  };

  const ScrollSection = (index: number) => {
    if (SectionRef1 && SectionRef2 && SectionRef3) {
      if (index === 0) SectionRef1.current?.scrollIntoView({ behavior: 'smooth' });
      if (index === 1) SectionRef2.current?.scrollIntoView({ behavior: 'smooth' });
      if (index === 2) SectionRef3.current?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    setIsOwner(fromType == '1' ? true : false);
    if (fromType) {
      // 0: 직원 1: 사업주
      FetchEmpInfo();
      FetchPayDetail();
    }
  }, [location.state]);

  const SectionRef1 = useRef<HTMLDivElement>(null);
  const SectionRef2 = useRef<HTMLDivElement>(null);
  const SectionRef3 = useRef<HTMLDivElement>(null);
  return (
    <WithSideBarAndNavBar>
      <div className="DetailPay">
        <DetailPayTop RealPay={RealPay} DetailData={DetailData} isOwner={isOwner} SELECT_DATE={date} />
        <DetailPayMid
          DetailData={DetailData}
          ProvideData={ProvideData}
          ProvideDataInfo={ProvideDataInfo}
          DeductionData={DeductionData}
          DeductionDataInfo={DeductionDataInfo}
          SectionRef1={SectionRef1}
          SectionRef2={SectionRef2}
          SectionRef3={SectionRef3}
          ScrollSection={ScrollSection}
          PAYTYPE={PAYTYPE}
        />
      </div>
    </WithSideBarAndNavBar>
  );
};

export default DetailPay;
